import React from "react";
import {Typography, Container, Grid, Box} from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";

interface PhasesContainerPropsInterface {
    activePhaseOrder: number;
    phaseObject: Array<{
        name: string;
        descriptor: string;
        order: number;
        isActive?: boolean;
    }>;
}

interface PhasesContainerStateInterface {
    activePhaseOrder: number;
}

class PhasesContainer extends React.Component<PhasesContainerPropsInterface, PhasesContainerStateInterface> {

    getPhaseStatus = (currentOrder: number) => {
        if (currentOrder < this.props.activePhaseOrder) {
            return (
                <Typography
                    variant="subtitle2"
                    style={{
                        fontSize: "12px",
                        color: "#6FCF97",
                        marginTop: "8px",
                        paddingBottom: "8px",
                    }}
                >
                    Completed
                </Typography>
            );
        } else if (currentOrder === this.props.activePhaseOrder) {
            if (currentOrder === this.props.phaseObject.length)
                return (
                    <Typography
                        variant="subtitle2"
                        style={{
                            fontSize: "12px",
                            color: "#6FCF97",
                            marginTop: "8px",
                            paddingBottom: "8px",
                        }}
                    >
                        Completed
                    </Typography>
                );
            return (
                <Typography
                    variant="subtitle2"
                    style={{
                        fontSize: "12px",
                        color: "#2F80ED",
                        marginTop: "8px",
                        paddingBottom: "8px",
                    }}
                >
                    In Progress
                </Typography>
            );
        } else {
            return (
                <Typography
                    variant="subtitle2"
                    style={{
                        fontSize: "12px",
                        color: "#F8B205",
                        marginTop: "8px",
                        paddingBottom: "8px",
                    }}
                >
                    Pending
                </Typography>
            );
        }
    };

    getPhaseIcon(currentOrder: number) {
        if (currentOrder < this.props.activePhaseOrder) {
            return (
                <CheckCircleOutlineIcon
                    style={{
                        color: "#6FCF97",
                        marginTop: "5px",
                    }}
                />
            );
        } else if (currentOrder === this.props.activePhaseOrder) {
            if (currentOrder === this.props.phaseObject.length)
                return (
                    <CheckCircleOutlineIcon
                        style={{
                            color: "#6FCF97",
                            marginTop: "5px",

                        }}
                    />
                );
            return (
                <RadioButtonUncheckedIcon
                    style={{
                        color: "#2F80ED",
                        marginTop: "5px",
                    }}
                />
            );
        } else {
            return (
                <RadioButtonUncheckedIcon
                    style={{
                        color: "#F8B205",
                        marginTop: "5px",
                    }}
                />
            );
        }
    }

    generatePhaseElements = () => {
        return this.props.phaseObject.map((phase) => {
            const border = phase.order === this.props.phaseObject.length ? "" : "1px solid #C9CED6";
            return (
                <Box>
                    <Grid container>
                        <Grid item lg={1} xs={2} style={{textAlign: "right", paddingRight: "16px", marginTop: "16px"}}>
                            {this.getPhaseIcon(phase.order)}
                        </Grid>
                        <Grid
                            item
                            lg={11}
                            xs={10}
                            style={{
                                paddingLeft: "0",
                                backgroundColor: "#FBFBFB",
                                borderBottom: border,
                            }}
                        >
                            <Typography
                                variant="h6"
                                style={{
                                    fontSize: "18px",
                                    color: "#0A1F44",
                                    marginTop: "16px",
                                    fontWeight: "bold",
                                }}
                            >
                                {phase.name}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                style={{fontSize: "14px", color: "#53627C", marginTop: "4px"}}
                            >
                                {phase.descriptor}
                            </Typography>
                            {this.getPhaseStatus(phase.order)}
                        </Grid>
                    </Grid>
                </Box>
            );
        });
    };

    render = () => {
        
        return (
            <Container maxWidth="md" style={{marginTop: "24px"}} disableGutters={true}>
                {this.generatePhaseElements()}
            </Container>
        );
    };
}

export default PhasesContainer;
